import { BiPhone } from "react-icons/bi";
import { FaWhatsapp } from "react-icons/fa";
import { FiMail } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useAuth } from "../../providers/auth.provider";

export default function Navbar() {
    const { partnerData } = useAuth();
    return (
        <nav className="container mx-auto flex justify-between items-center px-6 py-4">
            <div className="flex items-center">
                <Link to="/">
                    <img src={partnerData?.company_logo ? partnerData?.company_logo : "/assets/images/logo.png"} alt="Lark Finserv" className="h-10 w-auto" />
                </Link>
            </div>
            <div className="flex items-center space-x-6">
                <Link
                    to={`mailto:${partnerData?.company_email ? partnerData?.company_email : 'help@larkfinserv.com'}?subject=Enquiry%20for%20Loan%20Against%20Mutual%20Fund&body=Hi%20Team%2C%0D%0A%0D%0AI%20am%20interested%20in%20Loan%20Against%20Mutual%20Fund.%0D%0A%0D%0ALet%20me%20know%20if%20any%20thing%20needed.%0D%0A%0D%0AThanks!%0D%0A%0D%0A`}
                    className="text-blue-800 hover:text-gray-900 flex items-center gap-1"
                >
                    <FiMail className="" /> <span>Need help?</span>
                </Link>
                <Link to={`tel:+91${partnerData?.company_contact_no ? partnerData?.company_contact_no : '7836005500'}`} className="flex gap-1 justify-center items-center text-gray-700 hover:text-gray-900 sm:hidden md:flex">
                    <BiPhone className="text-blue-500 w-6 h-6" />
                    <span className="hidden sm:block">+91 {partnerData?.company_contact_no ? partnerData?.company_contact_no : '7836005500'}</span>
                </Link>
                <Link
                    to={`https://wa.me/${partnerData?.company_wa_no ? partnerData?.company_wa_no : '7836009900'}?text=I%20am%20interested%20in%20Loan%20Against%20Mutual%20Fund.%0D%0ALet%20me%20know%20if%20any%20thing%20needed.%0D%0A%0D%0AThanks!`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-1 sm:hidden md:flex"
                >
                    <FaWhatsapp className="text-green-500 w-6 h-6" />
                    <span className="hidden sm:block">Chat With Us</span>
                </Link>
            </div>
        </nav>
    )
}
